<template>
  <div>
    &nbsp;<modal-pallet-export ref="modal" @submitModal="addPalletGuia($event)"></modal-pallet-export>
    <b-button @click="$event.target.blur()" v-b-modal.modalAddPallets variant="secondary" ref="myBtnn"
      >Agregar Manualmente</b-button
    >
    &nbsp;&nbsp;&nbsp;
    <b-button @click="$event.target.blur()" :pressed.sync="buttonBarcodeScanner" :variant="variantBarcodeScanner">{{
      textBarcodeScanner
    }}</b-button>
    <br /><br />
    <!-- Modal Component -->
    <b-modal id="modalAddPallets" :title="titleModolaAddGuia" size="xl" class="modal-primary" hide-footer>
      <v-client-table :columns="columns" :data="data" :options="options" :theme="theme" id="dataTable">
        <div slot="pallet_number" slot-scope="props" align="center">
          <a href="#" @click.prevent="openModal(props.row)" class="text-primary" title="Agregar"
            ><i class="fa fa-lg fa-plus mt-1"></i
          ></a>

          &nbsp;
        </div>
      </v-client-table>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";

window.axios = require("axios");

import miniToastr from "mini-toastr"; // https://github.com/se-panfilov/mini-toastr
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import { bus } from "../../../main";
import modalPalletExport from "./modalPalletExport";

numeral.locale("es");

Vue.use(ServerTable);

export default {
  name: "AddPalletGuiaExportacion",
  components: {
    ServerTable,
    modalPalletExport
  },
  created() {},
  destroyed() {},
  props: [
    "waybill_id",
    "waybillDataExportacion",
    "formExportPalletData",
    "guiaPallets",
    "data",
    "PalletShipmentData",
    "addPalletswaybill",
    "updatePalletGuia"
  ],
  data() {
    return {
      titleModolaAddGuia: "Pallets",
      buttonBarcodeScanner: false,
      variantBarcodeScanner: "danger",
      textBarcodeScanner: "Activar Barcode",
      product: "",

      selected: {
        product_type: "",
        container: {
          id: ""
        }
      },
      selectOptions: {
        products: [],
        product_types: [],
        containers: []
      },
      theme: "bootstrap4",
      template: "default",
      columns: [
        "pallet_number",
        "number",
        "_origins",
        "_container",
        "_varieties",
        "_total_quantity",
        "_total_net_kilograms"
        // 'total_gross_kilograms',
      ],
      options: {
        headings: {
          pallet_number: "",
          number: "Pallet",
          _origins: "Huerto",
          _container: "Formato",
          _varieties: "Variedad",
          _total_quantity: "Cajas",
          _total_net_kilograms: "Kg Netos",
          _total_gross_kilograms: "Kg Brutos"
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Buscar",
          filterPlaceholder: "",
          count: "",
          limit: ""
        },
        perPage: 10

        // columnsDropdown: true,
        //filterByColumn: true,
      }
    };
  },
  methods: {
    addPalletGuia: function (row) {
      this.$emit("addPalletswaybill", row);
    },
    openModal(row) {
      this.$refs["modal"].$refs["modal"].show("modal-1");
      this.$refs["modal"].selected_row = row;
    },
    // Create callback function to receive barcode when the scanner is already done
    onBarcodeScannedPallet(barcode) {
      // miniToastr.success(`Pallet ${barcode} Escaneado ...`);

      let indice2 = this.guiaPallets.findIndex((numero) => numero.number === barcode);

      if (indice2 >= 0) {
        miniToastr.warn("Pallet ya ingresado");
      } else {
        let indice = this.data.findIndex((numero) => numero.number === barcode);
        if (indice >= 0) {
          this.openModal(this.data[indice]);
        } else {
          miniToastr.warn("Pallet no exite en el Instructivo de Embarque seleccionado ");
        }
      }
    },
    // Reset to the last barcode before hitting enter (whatever anything in the input box)
    resetBarcode() {
      let barcode = this.$barcodeScanner.getPreviousCode();
      // do something...
    }
  },
  mounted() {
    /*   const elem = this.$refs.myBtn
            elem.click(); */
  },
  computed: {},
  watch: {
    buttonBarcodeScanner(value) {
      if (value) {
        this.$barcodeScanner.init(this.onBarcodeScannedPallet);

        this.variantBarcodeScanner = "success";
        this.textBarcodeScanner = "Barcode Activo";
      } else {
        // Remove listener when component is destroyed
        this.$barcodeScanner.destroy();

        this.variantBarcodeScanner = "danger";
        this.textBarcodeScanner = "Activar Barcode";
      }
    }
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
